"use client";

import React, {useState} from "react";
import {Container} from "@/shared/components/shared";
import Image from "next/image";
import {Button} from "@/shared/components/ui/button";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

export const Contact: React.FC = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [name, setName] = useState('');
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    const getInputNumbersValue = (input: HTMLInputElement) => {
        return input.value.replace(/\D/g, '');
    }

    const onPhonePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        let input = e.currentTarget,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData('Text');
            if (/\D/g.test(pastedText)) {
                input.value = inputNumbersValue;
                return;
            }
        }
    }

    const onPhoneInput = (e: React.FormEvent<HTMLInputElement>) => {
        let input = e.currentTarget,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart || 0,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return input.value = "";
        }

        if (input.value.length != selectionStart) {
            const event = e.nativeEvent as InputEvent;
            if (event.data && /\D/g.test(event.data)) {
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols  = (inputNumbersValue[0] == "8") ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += '(' + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ') ' + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += '-' + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += '-' + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = '+' + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
        setPhoneNumber(formattedInputValue);
    }

    const onPhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        let input = e.currentTarget;
        let inputValue = input.value.replace(/\D/g, '');
        if (e.keyCode == 8 && inputValue.length == 1) {
            input.value = "";
        }
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsUniversalBookingOpen(true);
    };

    return (
        <>
            <section>
                <Container className={'pt-5 lg:pt-29'}>
                    <h2 className={'text-custom-orange font-bold text-[30px] lg:text-[70px] uppercase leading-[1.2] lg:text-center'}>Контакты</h2>
                    <div className="w-[331px] h-[331px] lg:w-[626px] lg:h-[626px] bg-custom-orange rounded-full mx-auto flex flex-col justify-center mt-10 lg:mt-18">
                        <h2 className={'text-white uppercase text-[24px] lg:text-[42px] leading-[1.2] text-center'}>
                            Мы рады вам<br/> 7 дней в неделю
                        </h2>
                        <div className={'flex flex-col mt-10 lg:mt-18 ml-14 lg:ml-29'}>
                            <div className={'flex'}>
                                <Image
                                    src={'/images/clock.svg'}
                                    alt={'часы'}
                                    width={45}
                                    height={45}
                                    className={'w-[25px] h-[25px] lg:w-[45px] lg:h-[45px]'}
                                />
                                <p className={'text-white text-[18px] lg:text-[32px] leading-[1.2] ml-4 lg:ml-8'}>
                                    09:00 - 20:00
                                </p>
                            </div>
                            <div className={'flex mt-4 lg:mt-5'}>
                                <Image
                                    src={'/images/phone.svg'}
                                    alt={'телефон'}
                                    width={41}
                                    height={41}
                                    className={'w-[23px] h-[23px] lg:w-[41px] lg:h-[41px]'}
                                />
                                <a href={'tel:+74232222999'} className={'text-white text-[18px] lg:text-[32px] leading-[1.2] ml-4 lg:ml-8'}>
                                    +7 (423) 2222-999
                                </a>
                            </div>
                            <div className={'flex mt-4 lg:mt-5'}>
                                <Image
                                    src={'/images/whatsapp.svg'}
                                    alt={'whatsapp'}
                                    width={43}
                                    height={43}
                                    className={'w-[24px] h-[24px] lg:w-[43px] lg:h-[43px]'}
                                />
                                <a href={'https://wa.me/74232222999'} target="_blank" rel="noopener noreferrer" className={'text-white text-[18px] lg:text-[32px] leading-[1.2] ml-4 lg:ml-8'}>
                                    +7 (423) 2222-999
                                </a>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className={'flex flex-col lg:flex-row justify-between pt-15 lg:pt-35 pb-12 lg:pb-35'}>
                    <h2 className={'text-custom-orange font-bold text-[30px] lg:text-[70px] uppercase leading-[1.2]'}>
                        давайте начнем<br/> наше знакомство!
                    </h2>
                    <form className={'flex flex-col mt-11 lg:mt-0'} onSubmit={handleSubmit}>
                        <input name="name"
                               value={name}
                               onChange={(e) => setName(e.target.value)}
                               required
                               className={'border-1 border-custom-ig pt-3 lg:pt-4 pb-3 lg:pb-4 pl-6 lg:pl-8 pr-6 lg:pr-8 rounded-[5px] text-[18px] lg:text-2xl leading-[1.1] focus:border-custom-light-orange outline-hidden'}
                               placeholder={'Ваше имя'}
                        />
                        <input name="phone"
                               required
                               className={'border-1 border-custom-ig pt-3 lg:pt-4 pb-3 lg:pb-4 pl-6 lg:pl-8 pr-6 lg:pr-8 mt-3 lg:mt-5 rounded-[5px] text-[18px] lg:text-2xl leading-[1.1] focus:border-custom-light-orange outline-hidden'}
                               placeholder={'+7 (000) 000-00-00'}
                               value={phoneNumber}
                               onChange={(e) => onPhoneInput(e)}
                               onPaste={onPhonePaste}
                               onKeyDown={onPhoneKeyDown}
                        />
                        <Button variant={'filledOrange'} type={'submit'} className={'pt-2 lg:pt-5 pb-2 lg:pb-5 pl-12 lg:pl-44 pr-12 lg:pr-44 font-button leading-none mt-4 lg:mt-9 text-[16px]'}>
                            записаться
                        </Button>
                    </form>
                </Container>
            </section>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Контакты"/>
        </>
    );
}